// import React from 'react'
// import { ActionIcon } from '@mantine/core'

// function Icon({ width, height, color = 'currentColor' }) {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       viewBox="0 0 16 16"
//       class="design-iconfont"
//       width={width}
//       height={height}
//     >
//       <g fill="none" fillRule="evenodd">
//         <path d="M0 0h16v16H0V0Z" />
//         <path
//           d="M13.21 8.002c0 2.861-2.36 5.208-5.304 5.208-2.462 0-4.515-1.64-5.122-3.85l-1.033.168c.691 2.714 3.185 4.724 6.155 4.724 3.504 0 6.345-2.799 6.345-6.25 0-3.452-2.84-6.25-6.345-6.25A6.368 6.368 0 0 0 2.79 4.304v-1.66H1.75v3.147a.5.5 0 0 0 .5.5h3.127V5.247H3.405a5.317 5.317 0 0 1 4.5-2.454c2.945 0 5.304 2.347 5.304 5.209Z"
//           fill={color}
//           fillRule="evenodd"
//         />
//       </g>
//     </svg>
//   )
// }

// const RotateIcon = (props) => {
//   const {
//     fill = 'blue',
//     variant = 'transparent',
//     size = 'lg',
//     radius = 'lg',
//     width = 20,
//     height = 20,
//     loading = false,
//     disabled = false,
//   } = props
//   return (
//     <ActionIcon
//       color={fill}
//       variant={variant}
//       size={size}
//       radius={radius}
//       loading={loading}
//       disabled={disabled}
//     >
//       <Icon width={width} height={height} />
//     </ActionIcon>
//   )
// }

// export default RotateIcon

import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont flex"
    >
      <path
        d="M13.21 8.002c0 2.861-2.36 5.208-5.304 5.208-2.462 0-4.515-1.64-5.122-3.85l-1.033.168c.691 2.714 3.185 4.724 6.155 4.724 3.504 0 6.345-2.799 6.345-6.25 0-3.452-2.84-6.25-6.345-6.25A6.368 6.368 0 0 0 2.79 4.304v-1.66H1.75v3.147a.5.5 0 0 0 .5.5h3.127V5.247H3.405a5.317 5.317 0 0 1 4.5-2.454c2.945 0 5.304 2.347 5.304 5.209Z"
        fillRule="evenodd"
      />
    </svg>
  )
}
const RotateIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
RotateIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-primary-color))',
}
// 参数类型
RotateIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default RotateIcon
